Vue = require 'vue'
eventHub = require '../event_hub.coffee'
formSubmitMixin = require '../mixins/form_submit.coffee'
{ last } = require 'es-toolkit/compat'

Vue.config.devtools = true

record_view = new Vue
  data: ->
    context: window.fi_transaction?.context
    description: window.fi_transaction?.description
    issued_at: window.fi_transaction?.issued_at
    reference: window.fi_transaction?.reference
    commercial_document_id: window.fi_transaction?.commercial_document_id
    commercial_document_total: window.commercial_document_total
    items: [] #window.transaction_items
    errors: []
    is_ready: true
    form_action: 'save' # 'save_and_new', 'save_and_export'
    tax_types: window.tax_types

  mixins: [formSubmitMixin]

  components:
    'datepicker': require('../components/simple_date_picker.coffee')
    'account-item': require('./components/account-item.coffee')


  created: ->
    eventHub.$on('removeItem', @removeItem)
    eventHub.$on('addEmptyItem', @addEmptyItem)

    if window.transaction_items
      Vue.set(@, 'items', window.transaction_items)

    if @items?.length is 0
      @addItem()
      @addItem()


  computed:
    count: -> @active_items.length

    active_items: -> @items.filter((item)=> not item._destroy and item.account_id)
    debit_items: -> @active_items.filter((item)=> item.debit_amount > 0)
    credit_items: -> @active_items.filter((item)=> item.credit_amount > 0)

    debits_total: ->
      @debit_items.reduce (sum, item)=>
        if @itemIsValid(item)
          sum.plus(item.debit_amount).plus(item.tax_amount)
        else
          sum
      , Big(0)

    credits_total: ->
      @credit_items.reduce (sum, item)=>
        if @itemIsValid(item)
          sum.plus(item.credit_amount).plus(item.tax_amount)
        else
          sum
      , Big(0)

    net_movement: -> @credits_total.minus(@debits_total)

    itemsIsValid: -> not @active_items.some (i)=> not @itemIsValid(i)
    hasItems: -> @active_items.length > 1
    netMovementIsZero: -> @net_movement.eq(0)

    debitsTotalRounded: -> round_money(@debits_total.toFixed(6), 6)
    creditsTotalRounded: -> round_money(@credits_total.toFixed(6), 6)
    netMovementRounded: -> round_money(@net_movement.toFixed(6), 6)


    isValidAttributes: ->
#      @description?
      @issued_at?

    creditsTotalIsValid: ->
      return true unless @commercial_document_id
      @commercial_document_total is parseFloat(@credits_total)

    isValid: ->
      @hasItems and @netMovementIsZero and @itemsIsValid and @creditsTotalIsValid and @isValidAttributes

    last_account_description: ->
      @active_items[@active_items.length - 1].description if @active_items.length >= 1

    next_position: ->
      return 0 if @items?.length == 0

      @items[@items.length - 1].position + 10



  methods:
    submitWithAction: (action, e)->
      return unless @isValid

      @form_action = action

      Vue.nextTick ->
        document.querySelectorAll('.js-btn-submit').forEach((el)=> el.classList.add('js-disabled'))
        document.querySelector('.fi-record-transaction-form').submit()

    addItem: (event)->
      item =
        id: null
        _destroy: null
        description: @last_account_description
        account_id: null
        debit_amount: 0
        credit_amount: 0
        issued_at: @issued_at
        tax_type_id: null
        tax_amount: 0
        position: @next_position
      @items.push item
      event and event.preventDefault()

    addEmptyItem: ()->
      console.log('EMPTY')
      last_item = last(@items)

      if last_item?.account_id?
        @addItem()

    removeItem: (data)->
      console.log('Remove Index', data.index)
      @items.splice(data.index, 1)

    itemIsValid: (item)->
      credit = round_number(item.credit_amount, 6)
      debit = round_number(item.debit_amount, 6)
      ((credit > 0 and debit is 0) or (debit > 0 and credit is 0)) and item.account_id isnt null


el = document.querySelector('.fi-record-form-wrapper')
record_view.$mount(el) if el
